<nz-select
    *ngIf="showSwitcher"
    class="data-project-switcher"
    nzSize="small"
    [nzDropdownMatchSelectWidth]="false"
    [nzOptionHeightPx]="25"
    [ngModel]="selectedKey"
    (ngModelChange)="onChange($event)"
>
    <nz-option
        *ngFor="let project of projects"
        [nzValue]="project.key"
        [nzLabel]="project.displayName"
    ></nz-option>
</nz-select>
